/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Button, Container, List, Toolbar } from "@mui/material";
import styles from "./NavBar.module.css";
import { Link, useNavigate } from "react-router-dom";
import DrawerMenu from "./DrawerMenu";
import { useEffect, useState } from "react";
import { Menu } from "@mui/icons-material";
import NavUser from "./NavUser";
import NavGoToMobileApp from "./NavGoToMobileApp";
import appStoreImage from "./App Store.jpg";
import googlePlayImage from "./Google Play.png";
import googlePlayIcon from "./icons8-google-play-30.png";
import appStoreIcon from "./icons8-app-store-30.png";

const navItems = [
  { id: 1, name: "Home", link: "/" },
  { id: 2, name: "Services", link: "/services" },
  { id: 3, name: "About Us", link: "/aboutUs" },
  { id: 4, name: "Contact Us", link: "/contact" },
];

const NavBar = () => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate("/", { state: { scrollToCategories: true } });
  };

  return (
    <nav position="static">
      <Container disableGutters>
        <Toolbar disableGutters>
          <div className={styles.toolbar}>
            <DrawerMenu />
          </div>
          <div className={styles.logoContainer}>
            <div>
              <Link to="/">
                <img
                  className={styles.logo}
                  style={{
                    height: window.innerWidth <= 770 ? "3rem" : "5rem",
                    paddingLeft: window.innerWidth <= 770 ? "0rem" : "1rem",
                  }}
                  alt="logo"
                  src={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/doneRightLogo.png`}
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
          <div className={styles.linkContainer}>
            <List className={styles.list}>
              {navItems.map((item) => (
                <Link className={styles.listItem} key={item.id} to={item.link}>
                  {item.name}
                </Link>
              ))}
            </List>
          </div>
          <div className={styles.mobAppSection}>
            <div className={styles.appLinks}>
              {/* <span className={styles.appText}>Get DoneRight App</span> */}
              <div className={styles.storeIcons}>
              {/* <span className={styles.appTextSide}>Get DoneRight App</span> */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.nach.doneright"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googlePlayImage}
                    alt="Google Play"
                    className={styles.storeImage}
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://apps.apple.com/ae/app/done-right/id6670172831"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appStoreImage}
                    alt="App Store"
                    className={styles.storeImage}
                    loading="lazy"
                  />
                </a>
              </div>
            </div>

            <div className={styles.userSection}>
              <Button
                variant="outlined"
                color="primary"
                className={styles.bookButton}
                onClick={handleBookNow}
              >
                Book Now
              </Button>
              <NavUser />
            </div>
          </div>
        </Toolbar>
      </Container>
    </nav>
  );
};

export default NavBar;
